import { TimesheetProvider } from ".";
import { fetchDraftTimesheetLog } from "../request-handler";

// Specific provider for draft timesheet logs
export const DraftTimesheetLogProvider = ({ date, children }) => {
  return (
    <TimesheetProvider
      date={date}
      filters={{ date }}
      endpoint="draft_timesheet"
      requestHandler={fetchDraftTimesheetLog}
      key={`draft-${date}`}
    >
      {children}
    </TimesheetProvider>
  );
};
